<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13Z"
      stroke="#292D32"
      stroke-width="1.37143"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      stroke="#292D32"
      stroke-width="1.37143"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 2.66927V1.33594"
      stroke="#292D32"
      stroke-width="1.37143"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.66683 8H1.3335"
      stroke="#292D32"
      stroke-width="1.37143"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 13.3359V14.6693"
      stroke="#292D32"
      stroke-width="1.37143"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.3335 8H14.6668"
      stroke="#292D32"
      stroke-width="1.37143"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>